export class ObjectUtils {
  public static isEmpty(obj: object): boolean {
    return Object.keys(obj).length === 0
  }

  /**
   * Remove properties with undefined, null, empty string, or empty array values from an object.
   * @param obj
   */
  public static cleanObject<T extends Record<string, any>>(obj: T): Partial<T> {
    const result: Partial<T> = {}
    for (const key in obj) {
      const value = obj[key]
      if (
        value !== undefined &&
        value !== null &&
        !(typeof value === 'string' && value.trim() === '') &&
        !(Array.isArray(value) && value.length === 0)
      ) {
        result[key] = value
      }
    }
    return result
  }

  /**
   * Remove duplicate elements in array by key value
   * @param arr
   * @param key
   */
  public static deduplicate(arr: any[], key: string): any[] {
    return arr.reduce((unique: any, o) => {
      if (!unique.some((obj: any) => obj[key] === o[key])) {
        unique.push(o)
      }
      return unique
    }, [])
  }

  /**
   * Compare simple JSON-style objects.
   * Is equal when both objects have the
   * same key-value pairs and ordering
   * @param obj1
   * @param obj2
   */
  public static isEqual(obj1: any, obj2: any): boolean {
    return JSON.stringify(obj1) === JSON.stringify(obj2)
  }

  /**
   * Sort array of strings in ascending order
   * @param arr
   * @param numeric
   */
  public static stringArraySort(arr: string[], numeric = false): string[] {
    return [...arr].sort((a, b) => a.localeCompare(b, undefined, { numeric }))
  }

  /**
   * Extract values from an object based on a provided property name
   * @param obj
   * @param propName
   */
  public static extractValues<T>(obj: Record<string, T>, propName: keyof T): Record<string, any> {
    return Object.keys(obj).reduce(
      (acc, key) => {
        acc[key] = obj[key][propName]
        return acc
      },
      {} as Record<string, any>,
    )
  }
}
